<template>
  <div id="loading">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading"
}
</script>

<style scoped>
#loading{
  height: 65vh;
}
#loading .row{
  height: 100%;
}
.loader {
  border: 3px solid var(--primary);
  border-top: 3px solid transparent;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  animation: spin 2s linear infinite;
  margin-top: 10vh;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Loading.vue